import { useTable } from 'spacetimedb/react';
import { tables as minetwinTables } from '@sdk/minetwin';

/**
 * Subscribed `cohort_progress` rows. Used by Review Queue (Completed filter),
 * Live Sessions (InProgress filter), and Leadership Dashboard (aggregation).
 *
 * Returns rows untransformed so each consumer can filter / sort / coerce
 * timestamps as it needs without paying for work others don't.
 */
export function useCohortProgress() {
  const [rows, isReady] = useTable('minetwin', minetwinTables.cohort_progress);
  return { rows, isReady };
}
